module.exports = __webpack_public_path__ + "static/enterprise-ireland-logo-46ff92d62603f3ce0cc5c8c98271c704.svg";